import { FormsValidationSummaryComponent } from './validation-summary/validation-summary.component';

export const FROMS_DECLARATIONS: any[] = [
    FormsValidationSummaryComponent,
];
